import WelcomeHome from '@/screens/WelcomeHome';

export default function PrivateWelcomeHomeRoute() {
  return <WelcomeHome />;
}
